import { Platform } from "react-native";

import { PlatformContext } from "./context";

import type { StoreProvider } from "./store";
import type { Context } from "react";
import type { PlatformProviderState } from "./types";

export const getPlatformContext = (): Context<
  StoreProvider<PlatformProviderState<"web" | "native">>
> => {
  switch (Platform.OS) {
    case "web":
      return PlatformContext as Context<
        StoreProvider<PlatformProviderState<"web">>
      >;
    case "android":
    case "ios":
      return PlatformContext as Context<
        StoreProvider<PlatformProviderState<"native">>
      >;
    default:
      throw new Error("Invalid Platform.OS");
  }
};
